import type { ColumnDef } from '@tanstack/react-table';

import { type GetNayaxMdbTemplatesQuery } from 'data/__generated__';
import { textColumn } from 'components/DataTable';

export type NayaxMDBTemplateRow = GetNayaxMdbTemplatesQuery['nayaxMDBTemplates'][number];

export const nayaxMDBTemplatesColumns: ColumnDef<NayaxMDBTemplateRow, unknown>[] = [
    textColumn<NayaxMDBTemplateRow, Record<string, unknown>>({
        accessorKey: 'name',
        header: 'Nom',
        defaultVisible: true,
    }),
];
